// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../resources/layout-and-structure/Box.res.js";
import * as I18n from "../primitives/I18n.res.js";
import * as Page from "../resources/layout-and-structure/Page.res.js";
import * as React from "react";
import * as Button from "../resources/actions/Button.res.js";
import * as TableView from "../resources/tables/TableView.res.js";
import * as BarControl from "../resources/layout-and-structure/BarControl.res.js";
import * as LegacyPagination from "../resources/navigation/LegacyPagination.res.js";
import * as JsxRuntime from "react/jsx-runtime";

let make = React.memo(props => JsxRuntime.jsx(Box.make, {
  children: JsxRuntime.jsx(Button.make, {
    label: I18n.t("Reset"),
    variant: {
      NAME: "ghost",
      VAL: {}
    },
    size: "small",
    icon: "cross",
    onPress: props.onPress
  }),
  spaceLeft: "xsmall"
}));

let ResetFiltersButton = {
  make: make
};

function LegacyResourceListPage(props) {
  let __searchBar = props.searchBar;
  let __banner = props.banner;
  let __actions = props.actions;
  let __filters = props.filters;
  let subtitle = props.subtitle;
  let filters = __filters !== undefined ? __filters : null;
  let actions = __actions !== undefined ? __actions : null;
  let banner = __banner !== undefined ? __banner : null;
  let searchBar = __searchBar !== undefined ? __searchBar : null;
  let pageVariation = subtitle !== undefined ? "standard" : "compact";
  let searchBar$1 = JsxRuntime.jsx(Box.make, {
    children: searchBar,
    spaceX: "large",
    spaceBottom: "xmedium"
  });
  return JsxRuntime.jsxs(Page.make, {
    children: [
      JsxRuntime.jsx(BarControl.make, {
        filters: filters,
        actions: actions,
        banner: banner
      }),
      JsxRuntime.jsx(TableView.make, {
        data: props.tableData,
        columns: props.tableColumns,
        keyExtractor: props.tableKeyExtractor,
        hideReloadingPlaceholder: true,
        placeholderEmptyState: props.tableEmptyState,
        searchBar: searchBar$1
      }),
      JsxRuntime.jsx(LegacyPagination.make, {
        currentPage: props.paginationCurrentPage,
        totalPages: props.paginationTotalPages,
        onRequestPaginate: props.onRequestPaginate
      })
    ],
    variation: pageVariation,
    title: props.title,
    subtitle: subtitle
  });
}

let make$1 = LegacyResourceListPage;

export {
  ResetFiltersButton,
  make$1 as make,
}
/* make Not a pure module */
